<template>
  <div class="main d-flex">
    <div class="navigation-ct">
      <div
        v-if="showNavLinkSection"
        class="nav-item-list"
      >
        <!-- <main-panel-links> -->
        <slot name="main-panel-links" />
      </div>
    </div>
    <div class="width-100">
      <!-- <main-panel-content> -->
      <slot name="main-panel-content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainPanel',
  data() {
    return {}
  },
  computed: {
    showNavLinkSection() {
      return !!this.$slots['main-panel-links']
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
</style>
